export default {
  state: {
    system_settings: {
      api_host: 'https://cc.dela.bz',
      mz_api_host: 'https://lk.morezvonkov.ru',
      websocket_host: 'wss://cc.dela.bz:4444/ws'
    }
  },
  mutations: {
    setApiHost (state, payload) {
      state.system_settings.api_host = payload
    },
    setWebSocketHost (state, payload) {
      state.system_settings.websocket_host = payload
    },
    setSystemSettings (state, payload) {
      state.system_settings = payload
    }
  },
  actions: {
    setApiHost ({commit}, payload) {
      commit('setApiHost', payload)
    },
    setWebSocketHost ({commit}, payload) {
      commit('setWebSocketHost', payload)
    },
    setSystemSettings ({commit}, payload) {
      commit('setSystemSettings', payload)
    }
  },
  getters: {
    system_settings (state) {
      return state.system_settings
    },
    route(state) {
      return (path) => {
        const newPath = path.startsWith('/') ? path : `/${path}`;
        return `${state.system_settings.api_host}${newPath}`;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/settings.js